const metaWithManager = {
  requiresAuth: true,
  onlyChainUser: true
}

export default {
  name: 'management-todo',
  path: 'todo',
  meta: { ...metaWithManager },
  component: () => import('@/views/app/management/ToDo/ToDo.vue')
}
